import { render, staticRenderFns } from "./ViewMenu.vue?vue&type=template&id=63bc3a7a&scoped=true&"
import script from "./ViewMenu.vue?vue&type=script&lang=ts&"
export * from "./ViewMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ViewMenu.vue?vue&type=style&index=0&id=63bc3a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc3a7a",
  null
  
)

export default component.exports